//@flow
import React from 'react';
import classnames from 'classnames';

import styles from './BenefitsChartRow.scss';

import type { Node } from 'react';

export const ROW_TYPE_CATEGORY: 'Category' = 'Category';
export const ROW_TYPE_CHILD_PROGRAM: 'Child Program' = 'Child Program';

type ROW_TYPE = typeof ROW_TYPE_CATEGORY | typeof ROW_TYPE_CHILD_PROGRAM;

type Props = {
    children: Node,
    type?: ROW_TYPE,
};

export function BenefitsChartRow(props: Props) {
    const { children, type = ROW_TYPE_CHILD_PROGRAM } = props;
    const isCategoryRow = type === ROW_TYPE_CATEGORY;

    const containerClass = classnames(styles.container, {
        [styles.categoryContainer]: isCategoryRow,
    });

    return <div className={containerClass}>{children}</div>;
}
